module.exports = __webpack_public_path__ + "static/img/left.127c34ae.png";